import { WORK_CHAT_HOME_PATH } from '@heidi/agents/contracts';
import { NEW_SESSION_LIST_PATH_PREFIX } from '@heidi/session/contracts';
import { AudioLines, House, type LucideIcon } from 'lucide-react';
import { type MessageDescriptor } from 'react-intl';
import { defaultLandingPageMessages } from './default-landing-page.messages';

/**
 * Values ml-scribe's settings catalog accepts for `ui-homepage`
 * (`Literal["home", "scribe"]`, oscerai/ml-scribe#19814). Adding an option is a
 * one-line change here plus the backend literal; the Settings dropdown and the
 * boot resolver (MUL-3718) both read this map.
 */
export const LANDING_PAGE_VALUES = ['home', 'scribe'] as const;

/** Settings deep-link anchor for the row; the search index builds its href from it. */
export const DEFAULT_LANDING_PAGE_SETTINGS_HASH = '#default-landing-page';

export type LandingPage = (typeof LANDING_PAGE_VALUES)[number];

/** Product default when the user has never chosen (matches the catalog default). */
export const DEFAULT_LANDING_PAGE: LandingPage = 'home';

export interface LandingPageOption {
  /** Route the app opens for this landing page. */
  route: string;
  icon: LucideIcon;
  label: MessageDescriptor;
}

export const LANDING_PAGE_OPTIONS: Record<LandingPage, LandingPageOption> = {
  home: {
    route: WORK_CHAT_HOME_PATH,
    icon: House,
    label: defaultLandingPageMessages.optionHome,
  },
  scribe: {
    route: NEW_SESSION_LIST_PATH_PREFIX,
    icon: AudioLines,
    label: defaultLandingPageMessages.optionScribe,
  },
};

export const isLandingPage = (value: unknown): value is LandingPage =>
  typeof value === 'string' && (LANDING_PAGE_VALUES as readonly string[]).includes(value);
